import AccountType from "@/services/company/accountType";

export default {
  computed: {
    showBuyLeads() {
      return this.companyDataExist
        ? this.$store.state.company.COMPANY.account.show_buy_leads
        : false;
    },
    canPayForLeads() {
      return this.companyDataExist
        ? this.$store.state.company.COMPANY.can_pay_for_leads || this.$store.state.company.COMPANY.buy_without_card
        : false;
    },
    showSettings() {
       return this.companyDataExist
         ? this.$store.state.company.COMPANY.account.show_settings
         : false;
    },
    displayHolidayModeLeadAlertToggle: function () {
      return this.companyDataExist
        ? this.$store.state.company.COMPANY.account.show_holiday_mode_lead_alert_toggle
        : false;
    },
    showFinance(){
      return this.companyDataExist
        ? this.$store.state.company.COMPANY.account.show_finance
        : false;
    },
    showInvoicePdf(){
      return this.companyDataExist
        ? this.$store.state.company.COMPANY.account.show_invoice_pdf
        : false;
    },
    showDashboard(){
      return !this.isKeyAccount;
    },
    isKeyAccount(){
      return this.companyDataExist
        && this.$store.state.company.COMPANY.account.type_id === AccountType.KEY
    },
    isLimitedAccount(){
      return this.companyDataExist
        && this.$store.state.company.COMPANY.account.type_id === AccountType.LIMITED
    },
    canPayByCard(){
      return this.companyDataExist
        ? this.$store.state.company.COMPANY.account.can_pay_by_card
        : false;
    },
    companyDataExist(){
      return this.$store.state.company.COMPANY !== null;
    },
  }
}
